module.exports = __webpack_public_path__ + "img/2.7400fa31.jpeg";